/**
 * DeliveryBoss brand logo.
 *
 * Renders the day-mode and night-mode artworks supplied by the brand owner.
 * The correct one is shown automatically based on the `dark` class on <html>
 * (toggled by ThemeContext). Files live in /app/frontend/public/logo/.
 *
 * Usage:
 *   <Logo className="h-9" />            // default sidebar/header size
 *   <Logo className="h-12 md:h-14" />   // hero / landing
 */
export default function Logo({ className = "h-9", alt = "DeliveryBoss" }) {
  return (
    <span
      className={`inline-flex items-center ${className}`}
      data-testid="brand-logo"
    >
      <img
        src="/logo/deliveryboss-day.png"
        alt={alt}
        className="block dark:hidden h-full w-auto object-contain select-none"
        draggable="false"
      />
      <img
        src="/logo/deliveryboss-night.png"
        alt={alt}
        className="hidden dark:block h-full w-auto object-contain select-none"
        draggable="false"
      />
    </span>
  );
}
